/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SdtPositionDto } from '../../models/sdt-position-dto';

export interface GetSdtPosition$Params {
  id: string;

/**
 * Get terser output with fewer fields filled in
 */
  terse?: boolean;
}

export function getSdtPosition(http: HttpClient, rootUrl: string, params: GetSdtPosition$Params, context?: HttpContext): Observable<StrictHttpResponse<SdtPositionDto>> {
  const rb = new RequestBuilder(rootUrl, getSdtPosition.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('terse', params.terse, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SdtPositionDto>;
    })
  );
}

getSdtPosition.PATH = '/v1/sdtpositions/{id}';
